import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'term',
  
})
export class TermPipe implements PipeTransform {

  private TERMS = {
    10: 'Winter',
    20: 'Spring',
    25: 'Spring Med',
    30: 'Summer',
    31: 'Summer',
    32: 'Summer',
    33: 'Summer',
    35: 'Summer Med',
    36: 'Employees',
    38: 'Academy',
    40: 'Fall',
    45: 'Fall Med'
  };

  public transform(termCode: string): string | null {

    if (!termCode || termCode.length !== 6) return null;

    const year = parseInt(termCode.slice(0, 4));
    const seasonCode = parseInt(termCode.slice(4, 6));
    const seasonDescription = this.TERMS[seasonCode as keyof typeof this.TERMS];

    if (!seasonDescription || !year) {
      return null;
    }

    if (seasonCode == 38) {
      const lastTwoOfYear = parseInt(year.toString().slice(2,4));
      return `${seasonDescription} ${lastTwoOfYear}-${lastTwoOfYear + 1}`;
    } else {
      return `${seasonDescription} ${year}`;
    }
  }
}